/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TokenV2Response } from './TokenV2Response';
import {
    TokenV2ResponseFromJSON,
    TokenV2ResponseFromJSONTyped,
    TokenV2ResponseToJSON,
    TokenV2ResponseToJSONTyped,
} from './TokenV2Response';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface GetTokenV2200Response
 */
export interface GetTokenV2200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetTokenV2200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetTokenV2200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {TokenV2Response}
     * @memberof GetTokenV2200Response
     */
    result?: TokenV2Response;
}

/**
 * Check if a given object implements the GetTokenV2200Response interface.
 */
export function instanceOfGetTokenV2200Response(value: object): value is GetTokenV2200Response {
    return true;
}

export function GetTokenV2200ResponseFromJSON(json: any): GetTokenV2200Response {
    return GetTokenV2200ResponseFromJSONTyped(json, false);
}

export function GetTokenV2200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTokenV2200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': json['result'] == null ? undefined : TokenV2ResponseFromJSON(json['result']),
    };
}

export function GetTokenV2200ResponseToJSON(json: any): GetTokenV2200Response {
    return GetTokenV2200ResponseToJSONTyped(json, false);
}

export function GetTokenV2200ResponseToJSONTyped(value?: GetTokenV2200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': TokenV2ResponseToJSON(value['result']),
    };
}

